var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVoteFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 11,
    fill: "none",
    viewBox: "0 0 13 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C66",
    d: "M11.83.98C11.4.62 10.93.39 10.4.3a3.32 3.32 0 0 0-2.93.98L7 1.75l-.47-.47A3.32 3.32 0 0 0 3.6.3a3.17 3.17 0 0 0-2.44 2.18c-.18.59-.21 1.2-.09 1.8.14.6.43 1.12.87 1.57l4.52 4.67a.74.74 0 0 0 1.08 0l4.52-4.7a3.37 3.37 0 0 0 .77-3.35c-.18-.59-.52-1.09-1-1.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVoteFilled);
export default __webpack_public_path__ + "static/media/icon-vote-filled.d9ffebba6bd26c0963affb2171a03b09.svg";
export { ForwardRef as ReactComponent };